import { MESSAGE_ID_ATTR } from 'conversations-message-history/web/message-history/constants/constants';
export const getLastDOMNodeMessageId = () => {
  const lastElement = document.querySelector(`[${MESSAGE_ID_ATTR}]:last-child`);
  if (lastElement && lastElement.getAttribute) {
    return lastElement.getAttribute(MESSAGE_ID_ATTR);
  }
  return null;
};